/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateSectionsControllerCreateMutationRequest, TemplateSectionsControllerCreateMutationResponse, TemplateSectionsControllerCreate400, TemplateSectionsControllerCreate401, TemplateSectionsControllerCreate403 } from "../../models/checklistsController/TemplateSectionsControllerCreate";

function getTemplateSectionsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/checklist-template-sections` as const }  
  return res
}

/**
 * @summary Create a new checklist template section
 * {@link /api/v1/checklist-template-sections}
 */
export async function templateSectionsControllerCreate(data?: TemplateSectionsControllerCreateMutationRequest, config: Partial<RequestConfig<TemplateSectionsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TemplateSectionsControllerCreateMutationResponse, ResponseErrorConfig<TemplateSectionsControllerCreate400 | TemplateSectionsControllerCreate401 | TemplateSectionsControllerCreate403>, TemplateSectionsControllerCreateMutationRequest>({ method : "POST", url : getTemplateSectionsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}